import { redText } from '@srcroot/utils/commonCss'

export const ErrorPageNotFound = () => {
  return <h1 className={redText()}>Error: page not found</h1>
}
